import Api from '../services/api.js'

export function createTrainingRequirementRequest(){
  return {
    type: 'CREATE_TRAINING_REQUIREMENT_REQUEST',
  }
}

export function createTrainingRequirementSuccess(body){
  return {
    type: 'CREATE_TRAINING_REQUIREMENT_SUCCESS',
    body: body
  }
}

export function createTrainingRequirementFailure(exception){
  return {
    type: 'CREATE_TRAINING_REQUIREMENT_FAILURE',
    exception: exception
  }
}

export function createTrainingRequirement(params) {
  return dispatch => {
    dispatch(createTrainingRequirementRequest())
    const api = new Api();
    return api.makeRequest({
        method: "post",
        url: `/api/v1/trainees/${params.trainee_id}/training_requirement`,
        params: params
      })
      .then(response => {
        dispatch(createTrainingRequirementSuccess(response.data))
      })
      .catch(err => {
        // error callback
        dispatch(createTrainingRequirementFailure(err))
      })
  }
}


export function updateTrainingRequirementRequest(){
  return {
    type: 'UPDATE_TRAINING_REQUIREMENT_REQUEST',
  }
}

export function updateTrainingRequirementSuccess(body){
  return {
    type: 'UPDATE_TRAINING_REQUIREMENT_SUCCESS',
    body: body
  }
}

export function updateTrainingRequirementFailure(exception){
  return {
    type: 'UPDATE_TRAINING_REQUIREMENT_FAILURE',
    exception: exception
  }
}

export function updateTrainingRequirement(params) {
  return dispatch => {
    dispatch(updateTrainingRequirementRequest())
    const api = new Api();
    return api.put(`/api/v1/training_requirements/${params.id}`, params)
    .then(response => {
      dispatch(updateTrainingRequirementSuccess(response.data))
    })
    .catch(err => {
      // error callback
      dispatch(updateTrainingRequirementFailure(err))
    })
  }
}


// WEBPACK FOOTER //
// ./src/actions/training_requirements.js